<template>
  <div class="banner" id="banner">
    <div class="banner__content">
      <div class="banner__logo">
        <img alt="" src="data:image/svg+xml;base64,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" />
      </div>
      <div class="banner__left">
        <div class="banner__title">
          Обменивайте валюту <br />в офисах СберБанка
        </div>
        <div class="banner__mobiledate">
          <strong>{{ updated }}</strong>
        </div>
        <div class="banner__button">
          <a href="https://sber-currency-exchange.rambler.ru" target="_blank">Найти офис</a>
        </div>
        <div class="banner__copyright">
          <strong>{{ updated }}</strong>
          <p>
            ПАО «Сбербанк» лицензия №1481. <span></span>Курс действует не во
            всех офисах Сбербанка, полная информация на сайте
            www.sberbank.ru
          </p>
        </div>
      </div>
      <div class="banner__right">
        <div class="banner__table">
          <div class="banner__table-head">
            <div class="banner__table-cell"></div>
            <div class="banner__table-cell">Купить</div>
            <div class="banner__table-cell">Продать</div>
          </div>
          <div
            class="banner__table-row"
            v-for="currency in currencies"
            :key="currency.symbol"
          >
            <div class="banner__table-item">{{ currency.symbol }}</div>
            <div class="banner__table-item">{{ currency.offer }}</div>
            <div class="banner__table-item">{{ currency.bid }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Main",
  data() {
    return {
      updated: "",
      currencies: [],
    };
  },
  created() {
    this.fetchCurrencyRates();
  },
  methods: {
    fetchCurrencyRates() {
      const urlParams = new URLSearchParams(window.location.search);
      const city = urlParams.get("city") || "moscow";
      const apiUrl = `https://sber-terminator-api.dev-sberseller.ru/api/banner/?city=${city}`;

      axios
        .get(apiUrl)
        .then((response) => {
          const { updated, data } = response.data;
          this.updated = updated;
          this.currencies = data;
        })
        .catch((error) => {
          console.error("Error fetching currency rates:", error);
        });
    },
  },
};
</script>

<style lang="sass" scoped>
.banner
  height: 300px
@media screen and (max-width: 600px)
  .banner__table-row .banner__table-item:nth-child(1)
    width: 57px
    font-size: 9px
    font-weight: bold !important
  .banner__table-row .banner__table-item:nth-child(2)
    width: 108px
    padding-right: 6px
    font-size: 9px
    font-weight: 400 !important
  .banner__table-row .banner__table-item:nth-child(3)
    width: 56px
    font-size: 9px
    font-weight: 400 !important
@media screen and (min-width: 599px) and (max-width: 1000px)
  .banner__content
    width: 600px
    padding-left: 17px
    padding-right: 42px
    box-sizing: border-box
  .banner
    &__logo
      width: 87px
    &__right
      width: 319px
      position: relative
      left: 13px
    &__title
      margin-top: 31px
      font-size: 20px
      padding-left: 36px
  .banner__table-head .banner__table-cell:nth-child(1)
    width: 134px
  .banner__table-head .banner__table-cell:nth-child(2)
    width: 115px
  .banner__table-row .banner__table-item:nth-child(1)
    width: 109px !important
    font-size: 11px
    font-weight: 700 !important
  .banner__table-row .banner__table-item:nth-child(2)
    width: 145px !important
    font-size: 11px
    font-weight: 400 !important
  .banner__table-row .banner__table-item:nth-child(3)
    padding-right: 5px
    font-weight: 400 !important
    font-size: 11px
  .banner__table-row
    height: 25px
    width: 100%
  .banner__table-head .banner__table-cell
    font-size: 11px
  .banner__table-head
    padding-top: 11px
  .banner__button
    right: 33px
    a
      display: block
      width: 121px
      height: 29px
      line-height: 29px
      text-align: center
      padding: 0
      font-size: 10px
      border-radius: 7px
      bottom: -2px
  @media screen and (min-width: 599px) and (max-width: 601px)
    .banner__table-row .banner__table-item:nth-child(1)
      width: 79px
    .banner__table-row .banner__table-item:nth-child(2)
      width: 95px
    .banner__table-row .banner__table-item:nth-child(3)
      width: 97px
  @media screen and (min-width: 969px) and (max-width: 999px)
    .banner__content
      width: 970px
      padding-left: 17px
      padding-right: 83px
      box-sizing: border-box
    .banner__copyright strong
      font-size: 10px
    .banner__table
      transform: scale(1.4)
      transform-origin: top left
      position: relative
      left: -118px
      top: 19px
    .banner
      &__logo
        width: 168px
      &__right
        width: 319px
        position: relative
        left: 13px
      &__button
        position: static
        a
          width: 271px
          border-radius: 12px
          font-size: 23px
          line-height: 56px
          height: 56px
          margin: 15px 94px
      &__content
        display: flex
        flex-direction: row
      &__title
        margin-top: 68px
        font-size: 28px
        width: 309px
        padding-left: 78px
        text-align: center
</style>
